import api from "@/Utils/api";

const cancelStripeSubscription = (subscriptionId: string) => api.del(`subscriptions/${subscriptionId}`) as Promise<{}>;

export {
    cancelStripeSubscription,
};
